import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/jacques-francois/latin-400.css";
import "@fontsource/kanit/latin-200.css";
import "@fontsource/krona-one/latin-400.css";
import "@fontsource-variable/noto-sans-sc";
import "@/styles/index.css";
import "country-flag-icons/3x2/flags.css";
import "@/styles/scheduled-task-settings.css";

import { AppProviders } from "@/app/AppProviders";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("缺少应用根节点 #root");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
